import { Template } from "./template.js";


const Left_menu = {
	data() {
		return {
			perPage: globalConstants.linesPerPageLeftMenu,
			currentPage: 1,
			filter: null,
			fields: [{
				key: 'name',
				label: '',
				sortable: true
			}],

		}
	},
	computed: {
		menuRows() {
			return this.users.length
		},
		rowClass() {}
	},
	props: {
		users: Array
	},
	methods: {
		userListClick(record, index) {
			console.log(record);
			this.$emit("line-click", record);
		},
		wire(item) {
			let icons = '';

			icons += (item.too_old ? '⏰' : '');
			//		if (icons == '') icons = '✅';
			return icons;


		},
		shortSerial(item) {
			if (item.serial)
				return item.serial.substring(0, 15) + (item.serial.substring(15, 16) ? '...' : '');
		}

	},
	template: Template
}

export { Left_menu }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/left_menu/component.js